import type { ReactElement } from "react";

import { translate } from "app/filters/i18nFilter";

import type { IOnboardingInfoModalProps } from "../components/OnboardingInfoModal/OnboardingInfoModal";
import OnboardingInfoModal from "../components/OnboardingInfoModal/OnboardingInfoModal";
import { ONBOARDING_INFO_DESCRIPTIONS_LIST } from "../constants/onboarding-info-descriptions-list";

const OnboardingInfoModalContainer = (
    props: Pick<IOnboardingInfoModalProps, "isOpen" | "onClose" | "onActionClick">,
): ReactElement => {
    return (
        <OnboardingInfoModal
            {...props}
            imageSrc="/images/sales-intelligence/successful-setup.svg"
            actionLabel={translate("si.onboarding.content.info.action-label")}
            title={translate("si.onboarding.content.info.title")}
            description={translate("si.onboarding.content.info.description")}
            descriptionList={ONBOARDING_INFO_DESCRIPTIONS_LIST}
        />
    );
};

export default OnboardingInfoModalContainer;
